import {BaseConfig} from "../../infrastructure/config/base-config";

export class GameCenterWidgetConfig extends BaseConfig {
  constructor() {
    super('gameCenterWidget');
  }
}
